const animation = {
  transition: 'all 400ms ease',
}

export default animation
